/**
 * employeeLocalState — the ONE list of browser-local (localStorage) records keyed by an AI
 * employee's id, and the purge that clears them when the employee is deleted.
 *
 * Why a separate tiny module: the purge runs from EmployeeListContext (in the main bundle, on the
 * shared CHAT_DELETED event), while the writers live in the Employee Computer's lazy chunk. This
 * module has no imports, so both sides can share the key prefixes without dragging the shell into
 * the entry bundle.
 *
 * Adding a new per-employee localStorage record? Import its prefix from here (so it is purged) —
 * a key built from an inline literal elsewhere is an orphan waiting to happen.
 *
 * Deletion strategy (AGENTS.md: any data tied to an Employee/Chat/Account needs one): the
 * backend's delete publishes CHAT_DELETED with chat_id == the employee anchor id; the context
 * purges the composer draft and calls purgeEmployeeLocalState. Other browsers that were offline
 * at that moment keep a few hundred bytes of dead keys — harmless, never read again (a deleted
 * id is never re-issued), and not worth a sweep.
 */

// Employee Computer session (open app windows, phone stack, boot flag) — windowStore.js.
export const EMPC_SESSION_PREFIX = 'cellcog_empc_session_v1_';
// Employee Computer remembered per-app window geometry — windowStore.js.
export const EMPC_GEOM_PREFIX = 'cellcog_empc_geom_v1_';
// Chats app: the human's chosen thread-pane width — EmployeeComputer/apps/ChatsApp/index.js.
export const EMPC_CHATS_THREAD_WIDTH_PREFIX = 'cellcog_ecch_thread_w_';

const PER_EMPLOYEE_PREFIXES = [
  EMPC_SESSION_PREFIX,
  EMPC_GEOM_PREFIX,
  EMPC_CHATS_THREAD_WIDTH_PREFIX,
];

// Remove every browser-local record for this employee. Idempotent; storage errors are swallowed
// (private mode has nothing to purge).
export const purgeEmployeeLocalState = (employeeId) => {
  if (!employeeId) return;
  try {
    PER_EMPLOYEE_PREFIXES.forEach((prefix) => localStorage.removeItem(prefix + employeeId));
  } catch {
    /* storage unavailable */
  }
};
